import React from 'react';

interface VanchiStatsCardProps {
  title: string;
  packedSent: number;
  received: number;
  packedSentIcon?: React.ReactNode;
}

const StatsCard: React.FC<VanchiStatsCardProps> = ({
  title,
  packedSent,
  received,
  packedSentIcon,
}) => {
  const formatValue = (val: number) => {
    // Check if val is a valid number
    if (typeof val !== 'number' || isNaN(val) || !isFinite(val)) {
      return '0';
    }
    
    try {
      return val.toLocaleString();
    } catch (error) {
      return val.toString();
    }
  };

  return (
    <div className="card h-100 fade-in card-wrap">
      <div className="card-body p-2">
        {/* Title at top left */}
        <h6 className="mb-3 text-primary card-title">
          {title}
        </h6>
        
        {/* Main content area with numbers and icon */}
        <div className="d-flex justify-content-center align-items-center card-content">
          {/* Left number */}
          <div className="d-flex card-countWrap flex-column align-items-center">
            <h4 className="text-primary card-count m-1">
              {formatValue(packedSent)}
            </h4>
            <p className='m-0 text-primary card-label'>Packed/Sent</p>
          </div>
          
          {/* Center icon */}
          <div className="card-icon d-flex card-countWrap flex-column align-items-center">
            {packedSentIcon && <span>{packedSentIcon}</span>}
          </div>
          
          {/* Right number */}
          <div className="d-flex card-countWrap flex-column align-items-center">
            <h4 className="text-primary card-count m-1">
              {formatValue(received)}
            </h4>
            <p className='m-0 text-primary card-label'>Received</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsCard;
